import ContentTemplateCompaniesTab from './ContentTemplateCompaniesTab';

export default ContentTemplateCompaniesTab;
